import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import FlightFilter from './Partial/FlightFilter'
import FlightSearchList from './Partial/FlightSearchList'
import { loaderActions } from '../../../../_actions/loader.actions'
import { getData, postUsersData } from '../../../../services/ApiCallingUserServices'
import { validateFlightSearchUrl } from '../../../../assets/js/URLPattern'
import { formatDate } from '../../../../components/commonClass/CommonValidation'
import { CommonFileURLWithFolder } from '../../../../ImageUpload/ImageCommon'
import FilterFormFlight from '../../partial/FilterFormFlight'
import { convertDurationToHM, fetchIp } from '../../../../components/commonClass/CommonFunctions'

const FlightList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [flightList, setFlightList] = useState<any>(null)
    const [filterFlightList, setFilterFlightList] = useState<any>(null)
    const [calendarfare, setCalendarFare] = useState([])
    const [datalist, setDataList] = useState<any>([]);
    const [apicalling, setapicalling] = useState(false)
    const [traceId, setTraceId] = useState('');
    const [formValue, setFormValue] = useState({
        EndUserIp: "",
        AdultCount: 1,
        ChildCount: 0,
        InfantCount: 0,
        JourneyType: 1,
        DirectFlight: false,
        OneStopFlight: false,
        IsAllowedOvernightStopOvers: false,
        IsFastest: false,
        IsCheapest: false,
        price: 0,
        PreferredAirlines: [],

        Segments: [{
            Origin: "DEL",
            Destination: "",
            FlightCabinClass: null,
            PreferredDepartureTime: null,
            PreferredDeparture: "",
            PreferredArrivalTime: "00:00:00",
        }],

        DepartureStartTime: null,
        DepartureEndTime: null,
        ArrivalStartTime: null,
        ArrivalEndTime: null,

        ReturnDepartureStartTime: null,
        ReturnDepartureEndTime: null,
        ReturnArrivalStartTime: null,
        ReturnArrivalEndTime: null
    })

    const getFlightList = async (form: any) => {
        dispatch(loaderActions.start());
        const userip = await fetchIp();
        if (userip?.status) {
            setFormValue((prev) => ({ ...prev, EndUserIp: userip?.data }));
            try {
                const payload = {
                    ...form, EndUserIp: userip?.data,
                    isGrouping: true
                };

                await postUsersData('/customerui/v1/getflightlistfilters', payload).then((rep) => {
                    if (rep?.status) {
                        rep?.data?.results?.map((obj: any) => {
                            obj.listPriceValue = obj?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson || 0;
                            obj.totalTimeDuration = obj?.segments?.map((el: any) => convertDurationToHM(el?.map((ele: any) => ({
                                duration: ele?.duration,
                                depTime: ele?.origin?.depTime,
                                arrTime: ele?.destination?.arrTime
                            })), true, true))?.reduce((sum: any, curr: any) => sum + curr, 0)

                            // this is for display fare from fare options(more fare)
                            obj.newFare = {
                                resultIndex: obj?.resultIndex,
                                fare: obj?.fare,
                                fareBreakdown: obj?.fareBreakdown,
                                fareClass: obj?.fareClassification?.type,
                                fareClassification: obj?.fareClassification,
                                fareInclusions: obj?.fareInclusions,
                                isLCC: obj?.isLCC,
                                isGSTMandatory: obj?.isGSTMandatory,
                            }
                            return obj;
                        })
                        setTraceId(rep?.data?.traceId ? rep?.data?.traceId : '')
                        setFlightList(rep?.data?.results ? rep?.data?.results : []);
                        if (form?.JourneyType === 2 && sessionStorage.getItem('isinternational') === 'false') {

                            const fromval = rep?.data?.results?.filter((flight: any) => {
                                return flight?.segments?.[0]?.some((segment: any) =>
                                    segment?.origin?.airport?.cityCode === searchParams?.get("fcc")
                                )
                            })?.map((flight: any) => ({
                                ...flight,
                                isFromCity: true,   // 👈 your flag
                            }));

                            const toval = rep?.data?.results?.filter((flight: any) => {
                                return flight?.segments?.[flight?.segments?.length - 1]?.some((segment: any) =>
                                    segment?.origin?.airport?.cityCode === searchParams?.get("tcc")
                                )
                            })?.map((flight: any) => ({
                                ...flight,
                                isFromCity: false,   // 👈 your flag
                            }));

                            const updatedval = [...fromval, ...toval];
                            setFilterFlightList(updatedval)
                        }
                        else {
                            setFilterFlightList(rep?.data?.results ? rep?.data?.results : [])
                        }
                    }
                    else {
                        setFlightList([]);
                        setFilterFlightList([])
                    }
                })

                if (payload?.JourneyType < 2) {
                    try {
                        const val = {
                            ...payload,
                            Segments: payload?.Segments?.map((segment: any) => {
                                const { PreferredDeparture, PreferredArrivalTime, ...rest } = segment;
                                return rest;
                            }),
                        }
                        getflightcalendarfare(val);

                    } catch (error) {
                        console.error("calendar fare error:" + error);
                        dispatch(loaderActions.end());
                    }
                }
            } catch (error) {
                console.error("calendar fare error:" + error);
                dispatch(loaderActions.end());
            }
        }

        setapicalling(false)
        const urlParams: any = new URLSearchParams(searchParams);
        urlParams.set('isExplore', false)
        setSearchParams(urlParams)

        dispatch(loaderActions.end());
    }

    const getflightcalendarfare = async (form: any) => {
        await postUsersData('/customerui/v1/getflightcalendarfare', form).then((rep) => {
            if (rep?.status) {
                setCalendarFare(rep?.data?.response?.searchResults ? rep?.data?.response?.searchResults : []);
            }
        })
    }

    const getFlightData = async () => {
        dispatch(loaderActions.start());
        await getData('/customerui/v1/getflightuiconfigurations')?.then((rep) => {
            setDataList(rep?.data)
            dispatch(loaderActions.end());
        })
    }

    const convertFilterObject = (filterData: any) => {
        let obj: any = {};
        Object.entries(filterData).forEach(([key, value]) => {
            obj[key] = value
        })
        return obj;
    }

    const transformMultiCityData = (input: any) => {
        const segments = [];
        const numberOfLegs = Object.keys(input).filter(key => key.startsWith('fcc')).length;
        for (let i = 1; i <= numberOfLegs; i++) {
            const fcc = input[`fcc${i}`]; // From city code
            const tcc = input[`tcc${i}`]; // To city code
            const departureDate = input[`DepartureDate${i}`];
            const segment = {
                Origin: fcc,
                Destination: tcc,
                FlightCabinClass: input?.class || 2,
                PreferredDepartureTime: departureDate ? departureDate + 'T00:00:00' : formatDate(new Date()) + 'T00:00:00',
                PreferredDeparture: formValue?.Segments?.[i]?.PreferredDeparture
                    ? departureDate + "T" + (formValue?.Segments?.[0]?.PreferredDeparture)?.split("T")?.[1]
                    : departureDate ? departureDate + 'T00:00:00' : formatDate(new Date()) + 'T00:00:00',
            };
            segments.push(segment);
        }
        return segments;
    }

    useEffect(() => {
        const obj = Object.fromEntries(searchParams.entries());
        if (obj?.isExplore === "true" || apicalling) {

            const filterFromUrl: any = {};
            setCalendarFare([])
            setFlightList(null);

            if (searchParams.size > 0 && datalist?.tripType?.length > 0) {
                const queryObject = Object?.fromEntries(searchParams?.entries());

                if (!validateFlightSearchUrl(queryObject)) {
                    navigate('*');
                }

                Object?.entries(queryObject)?.forEach(([key, value]) => {

                    if (key === 'tripType' || key === 'class') {
                        let curretKeyName = key === 'tripType' ? 'JourneyType' : key === 'class' ? 'FlightCabinClass' : ''
                        filterFromUrl[curretKeyName] = value;
                    } else if (key === 'adults' || key === "children" || key === "infants" || key === "price") {
                        const curretKeyName = key === 'adults' ? 'AdultCount' : key === 'children' ? 'ChildCount' : key === 'infants' ? 'InfantCount' : key === "price" ? 'price' : ''
                        filterFromUrl[curretKeyName] = Number(value);
                    } else if (key === 'DirectFlight' || key === 'OneStopFlight' || key === 'IsAllowedOvernightStopOvers' || key === "IsFastest" || key === "IsCheapest") {
                        filterFromUrl[key] = value === "true" ? true : false;
                    } else if (key === 'PreferredAirlines') {
                        filterFromUrl[key] = value ? value?.split(',') : [];
                    } else if (key === 'PreferredAirlines') {
                        filterFromUrl[key] = value ? value?.split(',') : [];
                    } else { filterFromUrl[key] = value ? value : [] }

                });

                const getUrlData = convertFilterObject(filterFromUrl);

                const getURLCityCodeDetails = datalist?.cityList.reduce((acc: any, city: any) => {
                    if (city.CityCode === queryObject?.fcc && city?.City === queryObject?.departure) {
                        acc.FromCode = city;
                    } else if (city.CityCode === queryObject?.tcc && city?.City === queryObject?.destination) {
                        acc.ToCode = city;
                    }
                    return acc;
                }, { FromCode: null, ToCode: null });

                const tripTypeURL = getUrlData?.JourneyType ? datalist?.tripType?.find((val: any) => val?.TripName?.toLowerCase() === getUrlData?.JourneyType?.toLowerCase())?.TripTypeId : datalist?.tripType?.[0]?.TripTypeId;
                const flightClassURL = getUrlData?.FlightCabinClass ? datalist?.travelClass?.find((val: any) => val?.Name?.toLowerCase() === getUrlData?.FlightCabinClass?.toLowerCase())?.BookingClassId : datalist?.travelClass?.[0]?.BookingClassId;
                if (getUrlData?.tripTypeURL < 3) {
                    if (!tripTypeURL || !flightClassURL || !getURLCityCodeDetails?.FromCode || !getURLCityCodeDetails?.ToCode || tripTypeURL === 1 && getUrlData?.ReturnDate) {
                        navigate('*');
                    }
                } else if (getUrlData?.tripTypeURL === 3) {
                    const numberOfLegs = Object.keys(getUrlData).filter(key => key.startsWith('fcc')).length;
                    for (let i = 1; i <= numberOfLegs; i++) {
                        if (getUrlData[`fcc${i}`] === getUrlData[`tcc${i}`]) {
                            navigate('*');
                        }
                    }
                }

                const FromCityToToCity = {
                    Origin: getUrlData?.fcc ? getUrlData?.fcc : 'DEL',
                    Destination: getUrlData?.tcc ? getUrlData?.tcc : '',
                    FlightCabinClass: flightClassURL,
                    PreferredDepartureTime: getUrlData?.DepartureDate ? getUrlData?.DepartureDate + 'T00:00:00' : formatDate(new Date()) + 'T00:00:00',
                    PreferredDeparture: formValue?.Segments?.[0]?.PreferredDeparture
                        ? getUrlData?.DepartureDate + "T" + (formValue?.Segments?.[0]?.PreferredDeparture)?.split("T")?.[1]
                        : getUrlData?.DepartureDate ? getUrlData?.DepartureDate + 'T00:00:00' : formatDate(new Date()) + 'T00:00:00',
                    // PreferredArrivalTime: formValue?.Segments?.[0]?.PreferredArrivalTime ? formValue?.Segments?.[0]?.PreferredArrivalTime : "00:00:00",
                }

                const formData = {
                    ...formValue,
                    //Home page 
                    AdultCount: getUrlData?.AdultCount ? getUrlData?.AdultCount : 1,
                    ChildCount: getUrlData?.ChildCount ? getUrlData?.ChildCount : 0,
                    InfantCount: getUrlData?.InfantCount ? getUrlData?.InfantCount : 0,
                    JourneyType: tripTypeURL,

                    //side filter
                    DirectFlight: getUrlData?.DirectFlight ? true : false,
                    OneStopFlight: getUrlData?.OneStopFlight ? true : false,
                    IsAllowedOvernightStopOvers: getUrlData?.IsAllowedOvernightStopOvers ? true : false,
                    IsFastest: getUrlData?.IsFastest ? true : false,
                    IsCheapest: getUrlData?.IsCheapest ? true : false,
                    price: getUrlData?.price ? getUrlData?.price : 0,
                    PreferredAirlines: getUrlData?.PreferredAirlines || [],

                    Segments: tripTypeURL < 3 ? tripTypeURL !== 2 ? [{ ...FromCityToToCity }] : [{ ...FromCityToToCity }, {
                        Origin: getUrlData?.tcc ? getUrlData?.tcc : '',
                        Destination: getUrlData?.fcc ? getUrlData?.fcc : 'DEL',
                        FlightCabinClass: flightClassURL,
                        PreferredDepartureTime: getUrlData?.ReturnDate ? getUrlData?.ReturnDate + 'T00:00:00' : formatDate(new Date()) + 'T00:00:00',
                        PreferredDeparture: formValue?.Segments?.[1]?.PreferredDeparture
                            ? getUrlData?.ReturnDate + "T" + (formValue?.Segments?.[0]?.PreferredDeparture)?.split("T")?.[1]
                            : getUrlData?.ReturnDate ? getUrlData?.ReturnDate + 'T00:00:00' : formatDate(new Date()) + 'T00:00:00',
                        // PreferredArrivalTime: formValue?.Segments?.[1]?.PreferredArrivalTime ? formValue?.Segments?.[0]?.PreferredArrivalTime : "00:00:00",
                    }] : transformMultiCityData(getUrlData)
                }

                setFormValue((prev: any) => ({
                    ...prev,
                    //Home page 
                    AdultCount: getUrlData?.AdultCount ? getUrlData?.AdultCount : 1,
                    ChildCount: getUrlData?.ChildCount ? getUrlData?.ChildCount : 0,
                    InfantCount: getUrlData?.InfantCount ? getUrlData?.InfantCount : 0,
                    JourneyType: tripTypeURL,

                    //side filter
                    DirectFlight: getUrlData?.DirectFlight ? true : false,
                    OneStopFlight: getUrlData?.OneStopFlight ? true : false,
                    IsAllowedOvernightStopOvers: getUrlData?.IsAllowedOvernightStopOvers ? true : false,
                    IsFastest: getUrlData?.IsFastest ? true : false,
                    IsCheapest: getUrlData?.IsCheapest ? true : false,
                    price: getUrlData?.price ? getUrlData?.price : 0,
                    PreferredAirlines: getUrlData?.PreferredAirlines || [],

                    Segments: tripTypeURL < 3 ? tripTypeURL !== 2 ? [{ ...FromCityToToCity }] : [{ ...FromCityToToCity }, {
                        Origin: getUrlData?.tcc ? getUrlData?.tcc : '',
                        Destination: getUrlData?.fcc ? getUrlData?.fcc : 'DEL',
                        FlightCabinClass: flightClassURL,
                        PreferredDepartureTime: getUrlData?.ReturnDate ? getUrlData?.ReturnDate + 'T00:00:00' : formatDate(new Date()) + 'T00:00:00',
                        PreferredDeparture: formValue?.Segments?.[1]?.PreferredDeparture
                            ? getUrlData?.ReturnDate + "T" + (formValue?.Segments?.[0]?.PreferredDeparture)?.split("T")?.[1]
                            : getUrlData?.ReturnDate ? getUrlData?.ReturnDate + 'T00:00:00' : formatDate(new Date()) + 'T00:00:00',
                        // PreferredArrivalTime: formValue?.Segments?.[1]?.PreferredArrivalTime ? formValue?.Segments?.[0]?.PreferredArrivalTime : "00:00:00",
                    }] : transformMultiCityData(getUrlData)
                }));
                // setapicalling(true)

                getFlightList(formData);

                // setapicalling(false)
                // const urlParams = new URLSearchParams(searchParams);
                // urlParams.set('isExplore', false)
                // setSearchParams(urlParams)
            }
        }
    }, [searchParams, datalist])

    const backgroundImage = useMemo(() => {
        return datalist?.bannerdetails?.[0]?.ImagePath
            ? `${CommonFileURLWithFolder}${datalist.bannerdetails[0].ImagePath}`
            : `${require("../../../../assets/img/no-image.png")}`;
    }, [datalist]);

    useEffect(() => {
        getFlightData()
    }, [])

    return (
        <>
            <section className="filterSec detailsBanner"
                style={{
                    background: `url(${backgroundImage})` + 'no-repeat center center / cover',
                }}>
                <div className="FilterDiv" style={{ position: 'relative' }}>
                    <div className="container">
                        <FilterFormFlight formValue={formValue} />
                    </div>
                </div>
            </section>

            {filterFlightList !== null && <section className="flight_section midSection">
                <div className="container">
                    <div className="row">
                        <FlightFilter filterFlightList={filterFlightList} setFlightList={setFlightList} flightList={flightList} formValue={formValue} searchParams={searchParams} datalist={datalist} />
                        <FlightSearchList
                            flightList={flightList}
                            filterFlightList={filterFlightList}
                            setFlightList={setFlightList}
                            setFormValue={setFormValue}
                            formValue={formValue}
                            setSearchParams={setSearchParams}
                            searchParams={searchParams}
                            calendarfare={calendarfare}
                            traceId={traceId}
                            datalist={datalist}
                            JourneyType={formValue?.JourneyType}
                        />

                    </div>
                </div>
            </section>}

        </>
    )
}

export default FlightList